var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"organization"},[_c('sk-input',{attrs:{"placeholder":_vm.placeholder,"preselected-value":_vm.organizationSearchKey},on:{"fieldvaluechanged":_vm.onInputBoxChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }